import { fetchWithoutToken } from '../utils/fetch';

export const getInfoUserKajabi = async (email, institutionCode) => {
	try {
		const res = await fetchWithoutToken.post(
			`/kajabi`,
			{
				email,
				institution_code: institutionCode,
			},
			{
				headers: {
					Authorization: `Bearer ${localStorage.token}`,
				},
			},
		);

		return res;
	} catch (error) {
		const backendDetail = error?.response?.data?.detail;
		const message = Array.isArray(backendDetail)
			? backendDetail.join(', ')
			: backendDetail || 'Kajabi authentication failed.';
		console.error('Kajabi auth error.', error);
		throw new Error(message);
	}
};
